import { render, staticRenderFns } from "./KLayout.vue?vue&type=template&id=0b57ca92&scoped=true&"
import script from "./KLayout.vue?vue&type=script&lang=js&"
export * from "./KLayout.vue?vue&type=script&lang=js&"
import style0 from "./KLayout.vue?vue&type=style&index=0&id=0b57ca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57ca92",
  null
  
)

export default component.exports